import { defineOptionalModule } from './contracts.js';
export const wamModule = defineOptionalModule({
    id: 'wam',
    displayName: 'WhatsAMusic',
    apiVersion: 1,
    lifecycle: 'ready',
    optional: true,
    runtime: 'agent-local',
    capabilities: ['wam.status.read', 'wam.control'],
    events: [],
    dependencies: [],
});
export const quizModule = defineOptionalModule({
    id: 'quiz',
    displayName: 'Quiz',
    apiVersion: 1,
    lifecycle: 'reserved',
    optional: true,
    runtime: 'agent-local',
    capabilities: [],
    events: [],
    dependencies: [],
});
export const jackboxModule = defineOptionalModule({
    id: 'jackbox',
    displayName: 'Jackbox',
    apiVersion: 1,
    lifecycle: 'reserved',
    optional: true,
    runtime: 'agent-local',
    capabilities: [],
    events: [],
    dependencies: [],
});
export const pubgModule = defineOptionalModule({
    id: 'pubg',
    displayName: 'PUBG',
    apiVersion: 1,
    lifecycle: 'reserved',
    optional: true,
    runtime: 'agent-local',
    capabilities: [],
    events: [],
    dependencies: [],
});
export const OPTIONAL_MODULES = Object.freeze([
    wamModule,
    quizModule,
    jackboxModule,
    pubgModule,
]);
export function readOptionalModule(value) {
    return OPTIONAL_MODULES.find((module) => module.id === value);
}
export function readyOptionalModules() {
    return OPTIONAL_MODULES.filter((module) => module.lifecycle === 'ready');
}
//# sourceMappingURL=registry.js.map